import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function  Mumbaitojalgaoncabbookingdhule() {



  const cardData = {
    keyword: " Mumbai to Jalgaon / Dhule Cab Booking",


"headingDescription": "Royal Route Cab offers reliable and comfortable Mumbai to Jalgaon and Dhule cab booking services, ensuring a safe, smooth, and convenient long-distance journey for families, business travelers, students, and group passengers. Whether you are planning a business trip, family visit, pilgrimage, or weekend travel, our professional drivers and well-maintained vehicles provide a stress-free travel experience. The Mumbai to Jalgaon route covers approximately 380 to 420 km and takes around 7 to 9 hours depending on traffic conditions, while Mumbai to Dhule covers approximately 340 to 370 km and takes around 6 to 8 hours. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and Tempo Travellers suitable for all types of travelers. With easy online booking and 24/7 customer support, Royal Route Cab is your trusted partner for Mumbai to Jalgaon and Dhule travel.",

"topPlaces": [
  {
    "title": "Padmalaya Ganpati Temple (Jalgaon)",
    "description": "Padmalaya Ganpati Temple is a highly revered pilgrimage site near Jalgaon dedicated to Lord Ganesha. It is believed to be one of the self-manifested Ganpati temples and attracts devotees seeking blessings for prosperity and removal of obstacles. The temple is surrounded by peaceful natural scenery and offers a calm spiritual atmosphere."
  },
  {
    "title": "Ajanta Caves (Near Jalgaon)",
    "description": "Ajanta Caves are a UNESCO World Heritage Site located near Jalgaon, famous for ancient Buddhist rock-cut caves, murals, and sculptures. These caves showcase India’s rich artistic heritage and are considered one of the finest examples of ancient Indian architecture and painting."
  },
  {
    "title": "Patna Devi Temple (Dhule Region)",
    "description": "Patna Devi Temple is a sacred hill temple located in the Satpura ranges near Dhule, dedicated to Goddess Patnadevi. It is surrounded by dense forests and waterfalls, making it a popular spiritual and nature destination."
  },
  {
    "title": "Songir Fort (Dhule)",
    "description": "Songir Fort is a historic hill fort near Dhule known for its strategic importance and panoramic views of the surrounding landscape. The fort offers trekking opportunities and a glimpse into the region’s Maratha-era history."
  },
  {
    "title": "Unapdev Hot Water Spring (Jalgaon District)",
    "description": "Unapdev Hot Water Spring is a natural thermal spring located in the Satpura hills, believed to have medicinal properties. It is a popular picnic and relaxation spot surrounded by greenery and peaceful forest surroundings."
  },
  {
    "title": "Gandhi Teerth (Jalgaon)",
    "description": "Gandhi Teerth is a modern research and educational center dedicated to Mahatma Gandhi’s life and philosophy. It houses exhibitions, archives, and interactive displays promoting peace, non-violence, and Gandhian values."
  },
  {
    "title": "Sardar Vallabhbhai Patel Museum (Jalgaon)",
    "description": "This museum showcases historical artifacts, freedom movement exhibits, and cultural heritage of the region. It is a great place for history enthusiasts and students to learn about India’s independence journey."
  },
  {
    "title": "Laling Fort (Dhule)",
    "description": "Laling Fort is an ancient fort located near Dhule offering trekking routes, scenic views, and historical ruins. It is a popular destination for adventure lovers and history explorers."
  },
  {
    "title": "Bahadarpur Dam (Dhule)",
    "description": "Bahadarpur Dam is a peaceful water reservoir surrounded by hills and greenery. It is ideal for picnics, photography, and enjoying calm sunset views in nature."
  },
  {
    "title": "Mehrun Lake (Jalgaon)",
    "description": "Mehrun Lake is a popular recreational spot in Jalgaon known for boating, gardens, and evening relaxation. It is a favorite destination for families and local visitors."
  }
],







services: [
  {
    name: "Mumbai to Jalgaon Cab",
    description: "Mumbai to Jalgaon cab service offers a comfortable and reliable journey to one of North Maharashtra’s key cities. This route is ideal for family travel, business visits, and tourism. Professional drivers ensure safe highway driving and timely arrival. Vehicles are well-maintained for long-distance travel. Customers can choose from sedan, SUV, and luxury cars. It guarantees a smooth and hassle-free journey."
  },
  {
    name: "Mumbai to Dhule Cab",
    description: "Mumbai to Dhule cab service provides a convenient and comfortable travel option for long-distance journeys. This service is ideal for business travelers and families. Clean vehicles and experienced drivers ensure safe travel. Flexible pickup options across Mumbai enhance convenience. It ensures a reliable and stress-free journey."
  },
  {
    name: "Mumbai to Jalgaon Taxi",
    description: "Mumbai to Jalgaon taxi offers door-to-door transportation with comfort and flexibility. This service is suitable for personal and corporate travel. Vehicles are driven by professional chauffeurs and maintained for long routes. Flexible travel schedules add convenience. It ensures a smooth travel experience."
  },
  {
    name: "Mumbai to Dhule Taxi",
    description: "Mumbai to Dhule taxi provides dependable travel for intercity journeys with a focus on comfort and safety. This service is ideal for families, tourists, and business clients. Clean interiors and trained drivers ensure a pleasant ride. It guarantees a stress-free and comfortable journey."
  },
  {
    name: "Mumbai to Jalgaon Cab Service",
    description: "Mumbai to Jalgaon cab service is designed for efficient long-distance travel with reliable vehicles and experienced drivers. This service is perfect for family trips, business travel, and tourism. Flexible pickup and drop options make it convenient. It ensures a comfortable and safe journey."
  },
  {
    name: "Mumbai to Dhule Taxi Service",
    description: "Mumbai to Dhule taxi service offers reliable transportation for long-distance routes. Vehicles are well-maintained and suitable for highway travel. Professional drivers ensure smooth and safe driving. Flexible scheduling allows easy travel planning. It ensures a dependable travel experience."
  },
  {
    name: "Cab from Mumbai to Jalgaon",
    description: "Cab from Mumbai to Jalgaon provides a private and comfortable travel experience. Travelers can enjoy flexible stops along the route. This service is ideal for families and small groups. Professional drivers ensure safe travel. It offers a relaxed and enjoyable journey."
  },
  {
    name: "Cab from Mumbai to Dhule",
    description: "Cab from Mumbai to Dhule offers personalized and convenient travel for long-distance journeys. This service is ideal for business trips and family travel. Clean vehicles and experienced drivers ensure comfort and safety. It ensures a smooth travel experience."
  },
  {
    name: "Mumbai to Jalgaon Cab Booking",
    description: "Mumbai to Jalgaon cab booking allows customers to reserve their ride easily with flexible travel options. Travelers can select vehicle type, pickup location, and travel date. Instant confirmation and transparent pricing ensure a hassle-free process. It simplifies trip planning."
  },
  {
    name: "Mumbai to Dhule Taxi Booking Online",
    description: "Mumbai to Dhule taxi booking online provides a quick and convenient way to book your journey. Customers can compare vehicle options and pricing easily. Secure payment and instant confirmation enhance convenience. It ensures availability during peak travel times."
  },
  {
    name: "Mumbai to Jalgaon Cab Price",
    description: "Mumbai to Jalgaon cab price varies based on vehicle type, trip type, and travel timing. Transparent pricing ensures no hidden charges. Budget-friendly and premium options are available. It helps travelers plan their trip efficiently. It ensures value for money."
  },
  {
    name: "Mumbai to Dhule Taxi Fare",
    description: "Mumbai to Dhule taxi fare is designed to be affordable and competitive for long-distance travel. Fare depends on vehicle type and travel plan. Customers receive clear pricing details before booking. Multiple options suit different budgets. It ensures cost-effective travel."
  },
  {
    name: "Mumbai to Jalgaon One Way Cab",
    description: "Mumbai to Jalgaon one way cab is a cost-effective option for travelers needing a single-side drop. This service eliminates return charges and offers flexible travel timings. Ideal for business trips and relocations. Comfortable vehicles ensure a smooth ride. It is perfect for budget travel."
  },
  {
    name: "Mumbai to Dhule Round Trip Taxi",
    description: "Mumbai to Dhule round trip taxi is ideal for travelers planning a return journey. This package includes pickup, drop, waiting time, and return travel. Flexible schedules make it convenient. Suitable for family and business trips. It ensures comfort and efficiency."
  },
  {
    name: "Mumbai to Jalgaon Innova Cab",
    description: "Mumbai to Jalgaon Innova cab is perfect for families and groups seeking spacious and comfortable travel. The vehicle offers ample seating and luggage space. Ideal for long-distance journeys. Professional drivers ensure safety. It provides a premium travel experience."
  },
  {
    name: "Mumbai to Dhule Ertiga Cab",
    description: "Mumbai to Dhule Ertiga cab is suitable for small groups and families looking for an affordable yet spacious ride. This vehicle offers comfortable seating and good mileage. It is ideal for budget-friendly travel. Drivers ensure smooth journeys. It ensures a pleasant experience."
  },
  {
    name: "Mumbai to Jalgaon Sedan Cab",
    description: "Mumbai to Jalgaon sedan cab is ideal for couples and small families seeking economical travel. Sedans offer smooth driving and comfort for long-distance trips. This option is widely preferred for its affordability. Professional drivers ensure safe travel. It is perfect for a relaxed journey."
  },
  {
    name: "Mumbai to Dhule SUV Taxi",
    description: "Mumbai to Dhule SUV taxi provides extra space and comfort for group travel. SUVs offer better stability and performance on highways. This option is ideal for families and corporate groups. Drivers ensure safe and reliable travel. It delivers a comfortable experience."
  }
],

tableData: [
  ["Mumbai to Jalgaon Cab", "Mumbai to Dhule Cab"],
  ["Mumbai to Jalgaon Taxi", "Mumbai to Dhule Taxi"],
  ["Mumbai to Jalgaon Cab Service", "Mumbai to Dhule Taxi Service"],
  ["Cab from Mumbai to Jalgaon", "Cab from Mumbai to Dhule"],
  ["Mumbai to Jalgaon Cab Booking", "Mumbai to Dhule Taxi Booking Online"],
  ["Mumbai to Jalgaon Cab Price", "Mumbai to Dhule Taxi Fare"],
  ["Mumbai to Jalgaon One Way Cab", "Mumbai to Dhule Round Trip Taxi"],
  ["Mumbai to Jalgaon Innova Cab", "Mumbai to Dhule Ertiga Cab"],
  ["Mumbai to Jalgaon Sedan Cab", "Mumbai to Dhule SUV Taxi"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Jalgaon & Dhule Travel",
    WhyChoosedescription: "Royal Route Cabs offers a smooth and comfortable Mumbai to Jalgaon and Dhule cab service, ideal for family travel, business trips, and long-distance journeys."
  },
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced on Mumbai to Jalgaon and Dhule routes, ensuring safe driving, proper navigation, and timely arrival."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear and upfront pricing including tolls, driver allowance, and all charges with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Mumbai to Jalgaon and Dhule cab service operates 24/7, allowing flexible travel anytime as per your schedule."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and regularly cleaned to ensure a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way cab service, round-trip bookings, or multi-day travel options for Jalgaon and Dhule trips."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for individuals and group travel."
  },
  {
    WhyChooseheading: "Trusted Outstation Cab Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by travelers for Mumbai to Jalgaon and Dhule cab bookings due to punctual service, professional drivers, and reliable experience."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai to Jalgaon and Dhule cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services from Mumbai to Jalgaon and Dhule for both one-way and round trips." },
  { question: "What is the distance between Mumbai and Jalgaon/Dhule?", answer: "The distance is approximately 400 to 450 km and takes around 8 to 10 hours depending on route and traffic." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Jalgaon and Dhule cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we offer pickup from home, hotel, and airport anywhere in Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended, especially during peak travel seasons and weekends." },
  { question: "Do you provide night travel service?", answer: "Yes, we provide safe night travel services with experienced drivers." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Harshad Patil",
    feedback: "Our Mumbai to Jalgaon trip with Royal Route Cabs was very comfortable. The ride was smooth, and the driver was professional and well-mannered throughout the journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Rekha More",
    feedback: "We booked a cab from Mumbai to Dhule and had a great experience. The vehicle was clean, and the entire journey was safe, timely, and hassle-free with Royal Route Cabs.",
    rating: 5
  }
];






















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Jalgaon / Dhule Cab Booking",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-to-jalgaon-dhule-cab.jpg", // replace if needed
  "description": "Book Mumbai to Jalgaon and Dhule cab with Royal Route Cabs for a safe, comfortable, and affordable long-distance journey. Choose from sedan, SUV, Innova, and luxury cars for one-way and round-trip taxi services with 24x7 availability.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6000", // adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-to-jalgaon-dhule-cab-booking"
  }
};






  return (
    <div>
<Helmet>
  <title>Mumbai to Jalgaon / Dhule Cab Booking | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai to Jalgaon and Dhule cab at best price with Royal Route Cabs. One-way & round-trip taxi service with sedan, SUV, Innova & luxury cars. Safe, reliable & 24x7 available."
  />

  <meta
    name="keywords"
    content="mumbai to jalgaon cab, mumbai to dhule cab, mumbai to jalgaon taxi, mumbai to dhule taxi, mumbai to jalgaon cab service, mumbai to dhule taxi service, cab from mumbai to jalgaon, cab from mumbai to dhule, mumbai to jalgaon cab booking, mumbai to dhule taxi booking online, mumbai to jalgaon cab price, mumbai to dhule taxi fare, mumbai to jalgaon one way cab, mumbai to dhule round trip taxi, mumbai to jalgaon innova cab, mumbai to dhule ertiga cab, mumbai to jalgaon sedan cab, mumbai to dhule suv taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/91.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitojalgaoncabbookingdhule;